import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeSubscription from "./StripeSubscription";

// Replace with your actual Stripe publishable key
// This should ideally come from an environment variable
const stripePromise = loadStripe(
  "pk_test_51REKHnQ2THmJYdbgS7nDIGgkxU8u4Q4JfBHOmTGzbMAWCQsNS4uFKSYgtFj825EjHrZE8GmQ5K65tyQQ1iHyYjt800CcCYrJkB"
);

const StripeWrapper = ({ planDetails, onSuccess, onCancel }) => {
  const options = {
    // Other Stripe options can be configured here
    locale: "en",
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <div className="stripe-wrapper">
        <StripeSubscription
          planDetails={planDetails}
          onSuccess={onSuccess}
          onCancel={onCancel}
        />
      </div>
    </Elements>
  );
};

export default StripeWrapper;
